import styled, { css } from "@doar/shared/styled";

export const StyledInputWrap = styled.div<{ $hasError?: boolean }>`
    ${({ $hasError }) =>
        $hasError &&
        css`
            margin-bottom: 8px;
        `}
`;
